import { render, staticRenderFns } from "./StateroomItem.vue?vue&type=template&id=715c096f&scoped=true"
import script from "./StateroomItem.vue?vue&type=script&lang=js"
export * from "./StateroomItem.vue?vue&type=script&lang=js"
import style0 from "./StateroomItem.vue?vue&type=style&index=0&id=715c096f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715c096f",
  null
  
)

export default component.exports